import { useAuth } from "../../../../auth/AuthenticationWrapper";
import { MdStore } from "react-icons/md";

const OpenCashInitialView = ({
    dailyCashFlow, open, handleInputChange, handleSubmit, openDailyCashFlow, loading, today
}) => {
    const { hasPermission } = useAuth();
    const canOpen = hasPermission("financial", "open_registry");

    if (!open) {
        return (
            <div className='flex flex-col items-center justify-center h-full text-center space-y-6'>
                <div className="bg-blue-50 p-6 rounded-full"><MdStore className="text-custom_blue text-5xl" /></div>
                <div><p className='font-bold text-2xl text-gray-800'>Caixa Fechado</p><p className='text-gray-500 text-sm mt-1'>{today}</p></div>
                <button type='button' className='bg-custom_blue hover:bg-blue-600 text-white py-3 px-8 rounded-xl font-bold shadow-lg transition-all disabled:opacity-50' onClick={openDailyCashFlow} disabled={!canOpen || loading}>Iniciar Abertura</button>
            </div>
        );
    }

    return (
        <div className={`flex flex-col items-center justify-center h-full space-y-6 transition-opacity duration-300 
        ${loading ? 'opacity-80 pointer-events-none' : 'opacity-100'}`}>
            <div className='flex flex-col items-center justify-center h-full space-y-6 animate-in fade-in zoom-in duration-300'>
                <div className="w-full max-w-xs">
                    <label className="block text-sm font-bold text-gray-700 mb-2 text-center">Valor Inicial (R$)</label>
                    <input
                        className={`block w-full px-4 py-3 text-xl font-bold text-center border-2 rounded-xl outline-none transition-colors
        ${loading
                                ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-slate-50 border-slate-200 text-gray-800 focus:border-custom_blue'
                            }`}
                        name="start_value"
                        type="number"
                        step={0.01}
                        value={dailyCashFlow.start_value}
                        onChange={handleInputChange}
                        placeholder="0.00"
                        autoFocus
                        disabled={loading}
                    />
                </div>
                <button
                    className={`py-3 px-12 rounded-xl font-bold shadow-lg transition-all w-full max-w-xs
        ${loading
                            ? 'bg-gray-400 cursor-not-allowed opacity-70'
                            : 'bg-green-500 hover:bg-green-600 text-white shadow-green-200'
                        }`}
                    onClick={handleSubmit}
                    disabled={!canOpen || loading}
                >
                    {loading ? (
                        <span className="flex items-center justify-center gap-2">
                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                            Processando...
                        </span>
                    ) : "Confirmar"}
                </button>
            </div>
        </div >
    );
};

export default OpenCashInitialView;